import { useState } from "react";
import ApiService from "../../services/ApiServiceClass";

export const useGetRequestByID = (requestID: number) => {
    
    const fetchRequestsByID = async () => {

        try {
            const responseData = await ApiService.getRequestByID(requestID);            
            return responseData.data;            
        } catch(error) {
            throw(error);
        }
    }

    return {fetchRequestsByID};
}
